import { AppRoutes } from '@gfe/app.paths';

/** Router commands to a plan's overview page, null while the dataspace or plan is unknown. */
export function planOverviewCommands(
  dataspaceId: number | string | undefined,
  planningSpaceId: string | undefined,
  planId: string | undefined
): string[] | null {
  if (dataspaceId === undefined || !planningSpaceId || !planId) return null;
  return ['/ds', String(dataspaceId), AppRoutes.plan.root, planningSpaceId, 'plan', planId];
}
